module.exports = __webpack_public_path__ + "img/pic_heyan@2x.ea3c2633.png";